import { create } from 'zustand';

interface DiffStore {
  diff: number;
  getDiff: () => void;
  setDiff: (diff: number) => void;
}

const useVpDiffStore = create<DiffStore>((set, get) => ({
  diff: 0,
  getDiff: () => {
    const { diff } = get();

    return diff;
  },
  setDiff: (diff: number) => {
    set((state) => ({ ...state, diff: diff }));
  },
}));

export default useVpDiffStore;
